<!--
 * @Author: DQL
 * @Date: 2020-03-16 14:37:40
 * @LastEditors: DQL
 * @LastEditTime: 2021-04-30 15:54:23
 * @Description: 菜单管理
 -->
<template>
  <div
    v-loading="loading"
    class="full-page page-menu"
  >
    <template v-if="isMenuSort">
      <!-- 菜单排序 -->
      <menu-sort
        :is-loading.sync="loading"
        @handleClose="handleMenuSort"
        @callback="handleSort"
      />
    </template>

    <!-- 树形导航类布局 Start -->
    <el-row
      v-else
      type="flex"
      class="l-page l-page--nav"
    >
      <!-- 左侧导航模块 Start -->
      <el-col
        class="l-page__aside"
        :xl="5"
        :lg="6"
        :md="8"
        :span="10"
      >
        <div
          class="l-page--inner l-page--aside"
        >
          <!-- 左侧头部 Start -->
          <div
            class="l-page__header"
          >
            <!-- 左侧标题 -->
            <h2
              class="c-page__header-title"
            >
              菜单树
            </h2>

            <!-- 左侧标题栏按钮区域 Start -->
            <div
              class="c-page__header-btns"
            >
              <el-button
                type="success"
                icon="kestrel-icon ki-colum-height"
                :disabled="!treeData || treeData.length===0"
                @click="handleMenuSort(true)"
              >
                菜单排序
              </el-button>
              <el-button
                type="primary"
                icon="kestrel-icon ki-plus"
                @click="handleClickAddFirstMenu()"
              >
                新增根菜单
              </el-button>
            </div>
            <!-- 左侧标题栏按钮区域 End -->
          </div>
          <!-- 左侧头部 End -->

          <!-- 左侧导航主内容 Start -->
          <div
            class="l-page__body"
          >
            <hm-page-card
              class="c-card--aside"
            >
              <!-- 树导航 Start -->
              <div
                class="c-asideTree"
              >
                <!-- 树导航：过滤条件 Start -->
                <div
                  class="c-asideTree__param"
                >
                  <el-input
                    v-model.trim="searchParam"
                    placeholder="菜单名称"
                    class="c-asideTree__param-input"
                    @keyup.native.enter="handleClickFilterMenu"
                  >
                    <el-button
                      slot="append"
                      icon="el-icon-search"
                      @click.prevent="handleClickFilterMenu"
                    />
                  </el-input>
                </div>
                <!-- 树导航：过滤条件 End -->
                <div
                  class="c-asideTree__body"
                >
                  <!-- tree的ref的命名根据业务名称修改 -->
                  <el-tree
                    v-if="!isFilterTree"
                    ref="menuTree"
                    class="c-asideTree__tree o-tree-overflow--unset"
                    node-key="nodeCode"
                    highlight-current
                    default-expand-all
                    :data="treeData"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    :filter-node-method="handleFilterNode"
                    @node-click="handleNodeClick"
                  />
                </div>
              </div>
              <!-- 树导航 End -->
              <div
                v-show="pageStatus=='editMenu' && canNotLeave"
                class="js-cancle-edit"
                @click="handleClickCancleEdit()"
              />
            </hm-page-card>
          </div>
          <!-- 左侧导航主内容 End -->
        </div>
      </el-col>
      <!-- 左侧导航模块 End -->

      <!-- 右侧主面板模块 Start -->
      <el-col
        :xl="19"
        :lg="18"
        :md="16"
        :span="14"
        class="l-page__panel"
      >
        <div
          v-if="!activeMenuCode"
          class="js-no-menu"
        >
          请选择左侧菜单进行管理！
        </div>
        <components
          :is="pageStatus"
          v-show="activeMenuCode"
          :menu="selectedMenu"
          :can-not-leave.sync="canNotLeave"
          :is-loading.sync="loading"
          @switch="handleSwitchPageStatus"
          @reload="handleReloadPage"
        />
      </el-col>
      <!-- 右侧主面板模块 End -->
    </el-row>
    <!-- 树形导航类布局 End -->

    <!-- 新增菜单 -->
    <add-menu-dialog
      v-if="showDialogName==='addMenu'"
      :dl-params="dialogParams"
      @closeDialog="handleReloadMenu"
    />
  </div>
</template>

<script>
import { getMenuTree, getMenu } from './menu.service.js';

export default {
  name: 'SysMenu',
  components: {
    addMenuDialog: () => import('./addMenuDialog'),
    editMenu: () => import('./editMenu'),
    viewMenu: () => import('./viewMenu'),
    menuSort: () => import('./menuSort')
  },
  data () {
    return {
      loading: false, // 页面loading状态

      isMenuSort: false, // 菜单排序显示状态

      /* 树组件配置 Start */
      isFilterTree: false, // 树过滤
      treeData: [], // 树组件数据
      // 树组件默认配置
      defaultProps: {
        children: 'childNodes',
        label: 'nodeName'
      },
      /* 树组件配置 End */

      searchParam: null, // 筛选菜单参数

      activeMenuCode: null, // 激活的菜单code

      selectedMenu: {}, // 选择的菜单

      pageStatus: null, // 页面状态：edit（编辑），view（查看）

      canNotLeave: false, // 处于编辑状态，不能离开

      /* 弹窗 Start */
      showDialogName: '',
      dialogParams: {
        parentMenuCode: null,
        parentMenuName: null
      }
      /* 弹窗 End */
    };
  },
  methods: {
    /**
     * @description: 获取系统菜单树
     * @param {_menuCode} 菜单code
     * @return {*} 有入参时，加载菜单树后，根据code获取菜单详细信息，树结构设置菜单高亮
     */
    getSystemMenuTree (_menuCode) {
      const _this = this;
      _this.loading = true;
      getMenuTree()
        .then(rsp => {
          // 菜单树赋值
          _this.treeData = rsp.data.childNodes;
          if (_menuCode) {
            // 加载菜单详细信息
            _this.initMenu(_menuCode);
            // dom加载后设置当前菜单项高亮
            _this.$nextTick(() => {
              _this.$refs.menuTree.setCurrentKey(_menuCode);
            });
          } else {
            // 菜单信息设为空
            this.selectedMenu = {};
          }
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 菜单树选择节点
     * @param {*}
     * @return {*}
     */
    handleNodeClick (data, node) {
      this.initMenu(data.nodeCode);
    },
    /**
     * @description: 过滤菜单树
     * @param {*}
     * @return {*}
     */
    handleClickFilterMenu () {
      this.$refs.menuTree.filter(this.searchParam);
    },
    /**
     * @description: 树组件过滤事件
     * @param {*}
     * @return {*}
     */
    handleFilterNode (value, data) {
      if (!value) return true;
      // 查询条件和对比值都转大写后再比对，忽略大小写的查询
      const upperValue = value.toLocaleUpperCase();
      return data.nodeName.toLocaleUpperCase().indexOf(upperValue) !== -1 && data.parentNodeCode !== '-1';
    },
    /**
     * @description: 初始化菜单信息
     * @param {*}
     * @return {*}
     */
    initMenu (_menuCode) {
      const _this = this;
      _this.loading = true;
      _this.activeMenuCode = _menuCode;
      getMenu(_menuCode)
        .then(rsp => {
          _this.selectedMenu = rsp.data;
          _this.pageStatus = 'viewMenu';
        })
        .finally(() => {
          _this.loading = false;
        });
    },
    /**
     * @description: 切换页面状态
     * @param {*}
     * @return {*}
     */
    handleSwitchPageStatus (_status) {
      if (_status === 'addMenu') {
        this.showDialogName = 'addMenu';
        this.dialogParams = {
          parentMenuCode: this.selectedMenu.menuCode,
          parentMenuName: this.selectedMenu.menuName,
          securityType: this.selectedMenu.securityType,
          securityName: this.selectedMenu.securityName
        };
      } else {
        this.pageStatus = _status;
      }
      this.canNotLeave = false;
    },
    /**
     * @description: 编辑状态点击菜单树，提醒取消修改
     * @param {*}
     * @return {*}
     */
    handleClickCancleEdit () {
      const _this = this;
      this.$confirm('菜单修改信息未保存，是否离开？', '提示', { type: 'warning' })
        .then(() => {
          _this.handleSwitchPageStatus('viewMenu');
          this.canNotLeave = false;
        })
        .catch(() => {
        });
    },
    /**
     * @description: 重新加载页面
     * @param {*}
     * @return {*}
     */
    handleReloadPage (_menuCode) {
      this.activeMenuCode = null;
      this.canNotLeave = false;
      this.getSystemMenuTree(_menuCode);
    },
    /**
     * @description: 重新加载菜单
     * @param {*}
     * @return {*}
     */
    handleReloadMenu (_menuCode) {
      this.showDialogName = null;
      if (_menuCode) {
        console.log('重新加载菜单', _menuCode);
        this.getSystemMenuTree(_menuCode);
      }
    },
    /**
     * @description: 添加一级菜单
     * @param {*}
     * @return {*}
     */
    handleClickAddFirstMenu () {
      this.showDialogName = 'addMenu';
      this.dialogParams = {};
    },
    /**
     * @description: 菜单排序
     * @param {*}
     * @return {*}
     */
    handleMenuSort (_status) {
      this.isMenuSort = _status;
    },
    /**
     * @description: 菜单排序回调
     * @param {*}
     * @return {*}
     */
    handleSort () {
      this.activeMenuCode = null;
      this.getSystemMenuTree();
    }
  },
  created () {
    this.getSystemMenuTree();
  }
};
</script>

<style scoped lang="scss">
.page-menu{
  .l-page--aside{
    position: relative;
  }
}

.js-cancle-edit{
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
}

.js-no-menu{
  display: flex;
  align-items: center;
  justify-content: 100%;
  justify-content: center;
  height: 1005;
  height: 100%;
  font-size: 20px;
  letter-spacing: 2px;
  color: #bdbdbd;
}

.full-page{
  height: 100%;
}
</style>
